var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "26px",
    viewBox: "0 0 23 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1284.000000, -33.000000)",
    fill: "#0C1229",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1280.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C12,1.63181017 11.7015232,1.33333333 11.3333333,1.33333333 C10.9651435,1.33333333 10.6666667,1.63181017 10.6666667,2 L10.6666667,4.036 C7.6294223,4.37557419 5.33274652,6.94383187 5.33333333,10 L5.33333333,17.8853333 L3.21866667,20 L19.448,20 L17.3333333,17.8853333 L17.3333333,10 C17.3339201,6.94383187 15.0372444,4.37557419 12,4.036 L12,2 Z M11.3333333,0 C12.4379028,0 13.3333333,0.8954305 13.3333333,2 L13.3333333,2.94266667 C16.412,3.81333333 18.6666667,6.64266667 18.6666667,10 L18.6666667,17.3333333 L22.6666667,21.3333333 L0,21.3333333 L4,17.3333333 L4,10 C4,6.71973604 6.17766559,3.8381513 9.33333333,2.94266667 L9.33333333,2 C9.33333333,0.8954305 10.2287638,0 11.3333333,0 Z M11.3333333,25.3333334 C9.7491046,25.3336567 8.38351239,24.2188875 8.06666667,22.6666667 L9.44666667,22.6666667 C9.72831265,23.4672956 10.4846101,24.0029733 11.3333333,24.0029733 C12.1820566,24.0029733 12.938354,23.4672956 13.22,22.6666667 L14.6,22.6666667 C14.2831543,24.2188875 12.9175621,25.3336567 11.3333333,25.3333334 L11.3333333,25.3333334 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.79f74f4122797aa9964d88bea130a109.svg";
export { ForwardRef as ReactComponent };